import { render, staticRenderFns } from "./SectionProgramFeatures.vue?vue&type=template&id=1080eaa3&"
import script from "./SectionProgramFeatures.vue?vue&type=script&lang=js&"
export * from "./SectionProgramFeatures.vue?vue&type=script&lang=js&"
import style0 from "./SectionProgramFeatures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports